module.exports = __webpack_public_path__ + "img/planet-mercury-internal.7f80fbf6.svg";